module.exports = __webpack_public_path__ + "img/tranquil_boots.516bc615.png";